import { MasterDataDto } from "@spike/masterdata-action";

/**
 * Organizations Login Response Structure
 * Endpoint: GET /api/v1/login_orgadmin
 * Params: email, password
 */
export interface OrganizationsLoginResponseDto {
  user: OrganizationsUserDto;
  master_data: MasterDataDto;
  time_zone?: string;
  organizations?: Array<OrganizationDto>;
}

/**
 * Organizations User Structure
 * Based on /api/v1/login_orgadmin response
 */
export interface OrganizationsUserDto {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  token: string;
  token_temporal: string;
  phone?: string;
  admin: boolean;
  active: boolean;
  org_access_level_id: 1 | 2; // 1=org admin, 2=org manager (only these levels allowed)
  created_at: string; // ISO string from backend
  updated_at: string; // ISO string from backend
  notifications_optout?: boolean;
  email_optout?: boolean;
  name?: string; // Full name from backend
  image?: string; // Gravatar URL
  marketplace_id: number | null; // null for org users
  profile_complete?: boolean | null;
  staff_id?: number | null;
  password_digest?: string; // Backend includes this but we don't use it
}

/**
 * Organization Structure for Enterprise
 */
export interface OrganizationDto {
  id: number;
  name: string;
  description?: string;
  created_at: Date;
  active: boolean;
  marketplaces_count?: number;
}

/**
 * Login Request Structure
 */
export interface OrganizationsLoginRequestDto {
  email: string;
  password: string;
}

/**
 * Organizations Access Level Definitions
 * Only org admin (1) and org manager (2) are allowed
 */
export enum OrgAccessLevel {
  ORG_ADMIN = 1,      // Organization admin - full access
  ORG_MANAGER = 2,    // Organization manager - limited access
}

export const OrgAccessLevelNames = {
  [OrgAccessLevel.ORG_ADMIN]: 'Organization Admin',
  [OrgAccessLevel.ORG_MANAGER]: 'Organization Manager'
} as const;

